<template>
	<div class="tabWrapper accountTabAllUsersComments">
		<no-info
				v-if="accountNotesList && accountNotesList.length <= 0"
				text="The information is not filled in, please fill in the user information"
		/>
		<div v-else class="main">
			<main-table
					v-if="(accountNotesList && accountNotesList.length > 0) && (accountNotesFilters && accountNotesList.length > 0)"
					padding="0"
					:flag="flag"
					:headers="getHeaders"
					:listItems="accountNotesList"
					:filtersList="accountNotesFilters"
					@updateClickButton="onClickButton($event, flag)"
					@updateSearch="onFilter"
					@updateRefreshFilters="onFilter"
					@updateChangeSort="onFilter"
					@updateStatusSwitch="onStatusSwitch"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { accountTabAllUsersComments } from "@/pages/Account/constants";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";

export default {
	name: "AccountTabAllUsersComments",
	components: { NoInfo },
	computed: {
		...mapGetters([
			'accountNotesList',
			'accountNotesFilters',
		]),
		getHeaders() {
			return accountTabAllUsersComments;
		},
	},
	data: () => ({
		flag: 'AccountTabAllUsersComments',
		list: null
	}),
	methods: {
		...mapActions([
			'getAccountNotesList',
			'getAccountNotesListFilter',
			'getAccountUpdateNotes',
			'getCountNotes',
		]),
		async onFilter({ filterModList }) {
			await this.getAccountNotesListFilter(filterModList);
		},
		async onStatusSwitch({ line }) {
			const { id, status } = line;
			await this.getAccountUpdateNotes({ id, status: Number(status) });
			await this.getCountNotes();
		},
	},
	async mounted() {
		await this.getAccountNotesList();
	}
};
</script>

<style scoped lang="scss"></style>
